import { FilterDateRange } from "@/presentation/deduction/components/DeductionFilter/interfaces";
import { FilterInfo } from "./deductionFilter.atoms";
import { ApprovalFilterInfo } from "@/store/approvals";
import { AccountingDataFilterInfo, AccountingRemittanceFilterInfo } from "@/store/accounting";

export const mapMonthsToFilterDateRange = (months: number): FilterDateRange | null => {
  switch (months) {
    case 1:
      return FilterDateRange.LAST_1_MONTH;
    case 3:
      return FilterDateRange.LAST_3_MONTHS;
    case 6:
      return FilterDateRange.LAST_6_MONTHS;
    case 12:
      return FilterDateRange.LAST_12_MONTHS;
    default:
      return null;
  }
};

export const getEmptyFilterInfo = (): FilterInfo => ({
  invoiceFromDate: null,
  invoiceToDate: null,
  checkFromDate: null,
  checkToDate: null,
  checkDateRange: null,
  invoiceDateRange: null,
  purchaser: [],
  dc: [],
  priority: [],
  validity: [],
  adjustmentTypes: [],
  adjustmentCategories: [],
  deductionTypeCategories: [],
  poNumberSearch: null,
  retailer: [],
  analyst: [],
  approver: [],
  progress: [],
});

const EMPTY_SEARCHABLE_TABLE_FILTER_INFO = {
  lastFilteredAt: null,
  search: null,
  checkFromDate: null,
  checkToDate: null,
  checkDateRange: null,
  invoiceFromDate: null,
  invoiceToDate: null,
  invoiceDateRange: null,
  purchaser: [],
  dc: [],
  glCode: [],
  analyst: [],
  approver: [],
  sortColumn: null,
  sortOrder: null,
} satisfies ApprovalFilterInfo & AccountingDataFilterInfo;

const getEmptySearchableTableFilterInfo = (): ApprovalFilterInfo & AccountingDataFilterInfo => ({
  ...EMPTY_SEARCHABLE_TABLE_FILTER_INFO,
});

export const getEmptyApprovalFilterInfo = (): ApprovalFilterInfo => getEmptySearchableTableFilterInfo();

export const getEmptyAccountingRemittanceFilterInfo = (): AccountingRemittanceFilterInfo => ({
  lastFilteredAt: null,
  search: null,
  checkFromDate: null,
  checkToDate: null,
  checkDateRange: null,
  purchaser: [],
  sortColumn: null,
  sortOrder: null,
});

export const getEmptyAccountingDataFilterInfo = (): AccountingDataFilterInfo => getEmptySearchableTableFilterInfo();